<template>
  <v-sheet color="transparent" width="200">
    <v-card class="mb-4" outlined width="180">
      <v-card-text>
        <v-responsive class="align-center text-center" :aspect-ratio="1/1">
        <img :src="require(`@/assets/appAsset-brand--${data.id}.svg`)" alt="Getnet" width="70%">
        </v-responsive>
      </v-card-text>
    </v-card>
    <v-list class="pl-0" color="transparent">
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">Sitio web</v-list-item-title>
          <v-list-item-subtitle>
            <v-btn :href="data.website" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">Guía de integración</v-list-item-title>
          <v-list-item-subtitle>
            <v-btn :href="`${$DOCS_BASE}${data.guide}`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">
            Settlement
            <v-tooltip color="primary" dark max-width="280" right transition="scale-transition">
              <template v-slot:activator="{on}">
                <v-icon class="mt-n1 ml-1" color="blue-grey darken-1" v-on="on" small>mdi-help-circle</v-icon>
              </template>
              <span class="white--text">Hace referencia al país donde la empresa debe estar constituida para recibir los pagos procesados a través de esta integración. Asegúrate de cumplir con este requisito para utilizarla.</span>
            </v-tooltip>
          </v-list-item-title>
          <v-list-item-subtitle>
            <img v-for="country in data.settlement" class="mt-2 mr-2" :alt="country" height="16px" :key="country" :src="require(`../../assets/appAsset-flag--${country}.svg`)">
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">Funciona con</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip v-if="data.compatibility.includes('subscriptions')" class="mt-2 mr-1" color="indigo" dark small>Suscripciones</v-chip>
            <v-chip v-if="data.compatibility.includes('payments')" class="mt-2 mr-1" color="indigo" dark small>Pagos</v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">Tipos de pago</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip v-if="data.allow_single_use" class="mt-2 mr-1" color="blue-grey darken-1" text-color="white" small>Únicos</v-chip>
            <v-chip v-if="data.allow_reusable_use" class="mt-2 mr-1" color="blue-grey darken-1" text-color="white" small>Recurrentes</v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pl-0">
        <v-list-item-content>
          <v-list-item-title class="body-2 text--secondary font-weight-medium">Monedas</v-list-item-title>
          <v-list-item-subtitle>
            <v-chip v-for="currency in data.currencies" class="mt-2 mr-1" color="blue-grey darken-1" :key="currency" text-color="white" small>{{currency}}</v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>